<template>
  <div class="safeContent" style="height: 100%; width: 100%">
    <div style="width: 100%; positon: relative">
      <img
        src="@/assets/img/banner.png"
        style="width: 100%; cursor: pointer"
        alt=""
        @click="clickBaner"
      />
    </div>
    <div style="width: 100%; height: 25px; position: relative">
      <a  href="https://www.wch.cn"  style="text-decoration: none; position: absolute; right: 3%; padding: 5px; border: 1px solid #46a0f8;color: #46a0f8;">
        返回主页面 <span style="text-decoration:underline">https://www.wch.cn</span>
        <!-- <img src="../assets/img/back.png" /> -->
      </a>
    </div>

    <div style="width: 1200px; position: relative; margin: 0 auto">
      <!-- 选型说明 -->
      <div
        style="
          height: 45px;
          line-height: 45px;
          color: #59aafe;
          margin-top: 18px;
          font-size: 20px;
          display: flex;
          font-weight: bold;
          justify-content: space-between;
          width: 1180px;
        "
      >
        <div style="display: flex">
          <div
            style="
              background: #59aafe;
              width: 13px;
              height: 45px;
              margin-right: 22px;
            "
          ></div>
          <div>选型说明</div>
        </div>

        <a target="_blank" href="http://www.wch.cn/contact_us.html">
          <img
            style="width: 153px;height:27px;margin-top: 10px;l"
            src="@/assets/img/about.png"
            alt=""
        /></a>
      </div>
      <div
        style="
          height: 78px;
          display: flex;
          justify-content: space-around;
          margin-top: 10px;
        "
      >
        <div style="width: 396px; height: 102px; position: relative">
          <img
            style="
              position: absolute;
              z-index: -1;
              width: 100%;
              height: 100%;
              left: 0;
            "
            src="@/assets/img/bg1.png"
            alt=""
          />
          <div style="display: flex">
            <div
              style="
                margin-left: 20px;
                width: 90px;
                color: #404448;
                font-weight: bold;
                margin-top: 11px;
                text-align: center;
                font-size: 13px;
                letter-spacing: 1px;
              "
            >
              <div style="height: 35px; line-height: 35px; margin-top: 1px">
                USB设备
              </div>
              <div style="height: 35px; line-height: 35px; margin-top: 6px">
                USB主机
              </div>
            </div>
            <div
              style="
                margin-left: 40px;
                width: 253px;
                color: #989b9d;
                height: 96px;
                font-size: 11px;
                font-weight: bolder;
                text-align: left;
              "
            >
              <div style="margin-top: 12px; height: 30px">
                模拟如键鼠/HID/U盘/CDC/音频/ <br />
                视频/自定义等设备
              </div>
              <div style="margin-top: 15px; height: 30px">
                类似电脑USB口，可操作如键鼠/ <br />U盘/打印机/自定义等设备
              </div>
            </div>
          </div>
        </div>
        <!-- 2 -->
        <div style="width: 396px; height: 102px; position: relative">
          <img
            style="
              position: absolute;
              z-index: -1;
              width: 100%;
              height: 100%;
              left: 0;
            "
            src="@/assets/img/bg1.png"
            alt=""
          />
          <div style="display: flex">
            <div
              style="
                margin-left: 20px;
                width: 90px;
                color: #404448;
                font-weight: bold;
                margin-top: 12px;
                text-align: center;
                font-size: 11px;
                letter-spacing: 1px;
              "
            >
              <div style="height: 35px">
                接口控制 <br />
                芯片
              </div>
              <div style="margin-top: 10px; height: 35px">USB<br />单片机</div>
            </div>
            <div
              style="
                margin-left: 40px;
                width: 253px;
                color: #989b9d;
                height: 78px;
                font-size: 11px;
                font-weight: bold;
                text-align: left;
              "
            >
              <div style="margin-top: 13px; height: 30px">
                作为其它微控制器的外设使用， <br />
                由普通接口操作完成USB功能
              </div>
              <div style="margin-top: 13px; height: 30px">
                内嵌USB的8051/RISC-V/RISC/ARM内 <br />
                核单片机，实现USB应用效率佳、性价比高
              </div>
            </div>
          </div>
        </div>
        <!-- 3 -->
        <div style="width: 396px; height: 102px; position: relative">
          <img
            style="
              position: absolute;
              z-index: -1;
              width: 100%;
              height: 100%;
              left: 0;
            "
            src="@/assets/img/bg2.png"
            alt=""
          />
          <div style="display: flex">
            <div
              style="
                margin-left: 20px;
                width: 90px;
                color: #404448;
                font-weight: bold;
                margin-top: 10px;
                text-align: center;
                font-size: 13px;
                letter-spacing: 1px;
              "
            >
              <div style="height: 25px; line-height: 25px">2.0全速</div>
              <div style="height: 25px; line-height: 25px; margin-top: 4px">
                2.0高速
              </div>
              <div style="height: 25px; line-height: 25px; margin-top: 1px">
                3.0超高速
              </div>
            </div>
            <div
              style="
                margin-left: 40px;
                width: 253px;
                color: #989b9d;
                height: 78px;
                font-size: 11px;
                font-weight: bold;
                text-align: left;
              "
            >
              <div style="margin-top: 12px; height: 20px; line-height: 20px">
                建议800KB/s以内的应用
              </div>
              <div style="margin-top: 9px; height: 20px; line-height: 20px">
                建议45MB/s以内的应用
              </div>
              <div style="margin-top: 7px; height: 20px; line-height: 20px">
                建议384MB/s以内的应用
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 主体部分 -->
      <div
        style="
          height: 688px;
          position: relative;
          display: flex;
          margin-top: 40px;
        "
      >
        <div style="width: 400px; height: 700px">
          <div id="leftBar"   style="width: 400px; text-align: left">
            <el-input
              clearable
              @input="changeValue"
              style="width: 250px; margin-left: 5px"
              size="small"
              placeholder="输入关键字进行过滤"
              v-model="filterText"
            >
            </el-input>

            <!-- 左侧树 -->
            <div
              id="showTree"
              :style="showTreeStyle"
              ref="showTree"
              @mouseenter="showTreeMouseenter"
              @mouseleave="showTreeMouseleave"
              style="
                width: 400px;
                height: 810px;
                overflow: auto;
                margin-top: 10px;
                background: white;
                transition: all 1s;
              "
            >
              <el-tree
                :expand-on-click-node="true"
                :highlight-current="true"
                :key="treeKey"
                :default-expanded-keys="expandKeys"
                ref="tree"
                class="filter-tree"
                :filter-node-method="filterNode"
                v-loading="!data.length"
                :props="defaultProps"
                :current-node-key="currentNode"
                :data="data"
                node-key="id"
                show-overflow-tooltip
                @node-click="handleNodeClick"
              >
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <div style="display: inline-block">
                    <span v-if="data.url">
                      <a
                        target="_blank"
                        style="color: #606266"
                        :href="data.url"
                      >
                        <span
                          style="
                            border-bottom: 1px solid #61affe;
                            display: inline-block;
                            line-height: 15px;
                            color: #488ff4;
                            font-weight: bold;
                          "
                          >{{ node.label }}</span
                        >
                      </a>
                    </span>
                    <span v-else style="color: #488ff4; cursor:initial">
                      {{ node.label }}
                    </span>
                  </div>
                  <el-tooltip
                    style="z-index: 9999"
                    class="item"
                    :open-delay="400"
                    effect="dark"
                    :content="data.detail"
                    placement="top-start"
                  >
                    <a
                      target="_blank"
                      style="color: #606266; text-decoration: none"
                      :href="data.url"
                    >
                      <span style="margin-left: 5px"> {{ data.detail }}</span>
                    </a>
                  </el-tooltip>
                </span>
              </el-tree>
            </div>
          </div>
        </div>
        <!-- 右侧引脚 -->
        <div
          class="rightPart"
          style="
            z-index: 9;
            text-align: center;
            width: 760px;
            margin-left: 20px;
            position: relative;
            color: #333;
          "
        >
          <!-- 主体 -->
          <div style="height: 685px">
            <img
              src="@/assets/img/pic.png"
              style="
                width: 760px;
                height: 680px;
                position: absolute;
                top: 0;
                left: 0;
              "
              alt=""
            />
            <!-- usb芯片 -->
            <div
              class="common"
              @click="handleBtn(1, 1)"
              style="
                position: absolute;
                top: 275px;
                right: 320px;
                width: 116px;
                height: 116px;
                border-radius: 50%;
              ">
            </div>

            <!-- 1.USB专用功能 -->
            <div>
              <div
                class="common bigTitle"
                :class="{ activeCenter: currentNum == 2 }"
                @click="handleBtn(2, 1)"
                style="
                  position: absolute;
                  top: 304px;
                  right: 165px;
                  width: 75px;
                  height: 63px;
                "
              >
                <div style="margin-top: 10px">USB</div>
                <div style="margin-top: 5px">专用功能</div>
              </div>
              <div style="position: absolute; top: 51px; right: 0px">
                <!-- top:43px;right:-2px; -->
                <div
                  class="rightChildCommon middleTitle"
                  style="line-height: 30px"
                >
                  <div
                    @click="handleBtn(203, 1)"
                    :class="{ activeColor: currentNum == 203 }"
                    class="commonBtn"
                    style="">
                    USB HUB 集线器
                  </div>
                   <div
                    @click="handleBtn(308, 1)"
                    :class="{ activeColor: currentNum == 308 }"
                    class="commonBtn">
                    USB网卡
                  </div>
                  <div
                    @click="handleBtn(215, 1)"
                    :class="{ activeColor: currentNum == 215 }"
                    class="commonBtn">
                    USB读卡器
                  </div>
                  <div
                    @click="handleBtn(160, 1)"
                    :class="{ activeColor: currentNum == 160 }"
                    class="commonBtn"
                    style="color: #dc381a">
                    USB PD协议/电源类
                  </div>
                  <div
                    @click="handleBtn(197, 1)"
                    :class="{ activeColor: currentNum == 197 }"
                    class="commonBtn">
                    KVM应用
                  </div>
                  <div
                    @click="handleBtn(3, 1)"
                    style="line-height: 14px;"
                    :class="{ activeColor: currentNum == 3 }"
                    class="commonBtn">
                    模拟键盘/鼠标/U盘/HID类设备
                  </div>
                  <!-- <div
                    @click="handleBtn(8, 1)"
                    :class="{ activeColor: currentNum == 8 }"
                    class="commonBtn">
                    模拟HID兼容类设备
                  </div>
                  
                  <div
                    @click="handleBtn(11, 1)"
                    :class="{ activeColor: currentNum == 11 }"
                    class="commonBtn">
                    模拟U盘设备
                  </div> -->
                  <div
                    @click="handleBtn(15, 1)"
                    :class="{ activeColor: currentNum == 15 }"
                    class="commonBtn" >
                    模拟声卡/摄像头设备
                  </div>
                  <div
                    @click="handleBtn(17, 1)"
                    style="line-height: 14px;"
                    :class="{ activeColor: currentNum == 17 }"
                    class="commonBtn">
                    操作键盘/鼠标/U盘/HID类设备
                  </div>
                  <!-- <div
                    @click="handleBtn(20, 1)"
                    :class="{ activeColor: currentNum == 20 }"
                    class="commonBtn">
                    操作U盘，带文件系统
                  </div> -->
                  <div
                    @click="handleBtn(32, 1)"
                    :class="{ activeColor: currentNum == 32 }"
                    class="commonBtn"
                    style="color: #dc381a; ">
                    USB延长/隔离
                  </div>
                  <div
                    @click="handleBtn(24, 1)"
                    :class="{ activeColor: currentNum == 24 }"
                    class="commonBtn">
                    USB转单串口/多串口
                  </div>
                  <div
                    @click="handleBtn(25, 1)"
                    :class="{ activeColor: currentNum == 25 }"
                    class="commonBtn"
                    style="line-height: 12px;margin-bottom: 8px;">
                    USB转JTAG&SPI&I2C其他接口
                  </div>
                  <div
                    @click="handleBtn(30, 1)"
                    :class="{ activeColor: currentNum == 30 }"
                    class="commonBtn">
                    USB转蓝牙
                  </div>
                  
                  <!-- <div
                    @click="handleBtn(219, 1)"
                    :class="{ activeColor: currentNum == 219 }"
                    class="commonBtn"
                    style="color: #dc381a; ">
                    USB隔离
                  </div> -->
                  
                  <div
                    @click="handleBtn(39, 1)"
                    :class="{ activeColor: currentNum == 39 }"
                    class="commonBtn">
                    其他功能或方案
                  </div>
                </div>
              </div>
            </div>

            <!--2.USB主机功能  -->
            <div>
              <div
                class="common bigTitle"
                :class="{ activeColor: currentNum == 88 }"
                @click="handleBtn(88, 2)"
                style="
                  border-radius: 5px;
                  width: 80px;
                  height: 60px;
                  position: absolute;
                  top: 305px;
                  left: 277px;
                "
              >
                <div style="margin-top: 10px">USB</div>
                <div style="margin-top: 5px">主机功能</div>
              </div>
              <div
                class="leftCommon middleTitle"
                style="
                  line-height: 30px;
                  position: absolute;
                  top: 172px;
                  left: 146px;
                "
              >
                <div
                  class="commonBtn"
                  :class="{ activeColor: currentNum == 89 }"
                  @click="handleBtn(89, 2)"
                >
                  一个USB口
                </div>
                <div
                  @click="handleBtn(111, 2)"
                  :class="{ activeColor: currentNum == 111 }"
                  class="commonBtn"
                  style="margin-top: 108px"
                >
                  两个USB口
                </div>
                <div
                  @click="handleBtn(119, 2)"
                  :class="{ activeColor: currentNum == 119 }"
                  class="commonBtn"
                  style="margin-top: 87px"
                >
                  三个USB口
                </div>
                <div
                  @click="handleBtn(125, 2)"
                  :class="{ activeColor: currentNum == 125 }"
                  class="commonBtn"
                  style="margin-top: 45px"
                >
                  四个USB口以上
                </div>
              </div>
              <div style="position: absolute; top: 124px; left: 0px">
                <div class="leftChildCommon smallTitle">
                  <div
                    @click="handleBtn(90, 2)"
                    :class="{ activeColor: currentNum == 90 }"
                    class="commonBtn"
                    style="margin-top: 8px"
                  >
                    免编程功能桥接芯片
                  </div>
                  <div
                    @click="handleBtn(93, 2)"
                    :class="{ activeColor: currentNum == 93 }"
                    class="commonBtn"
                    style="margin-top: 8px"
                  >
                    接口控制芯片
                  </div>
                  <div
                    @click="handleBtn(99, 2)"
                    :class="{ activeColor: currentNum == 99 }"
                    class="commonBtn"
                    style="margin-top: 8px"
                  >
                    USB单片机
                  </div>

                  <div
                    @click="handleBtn(112, 2)"
                    :class="{ activeColor: currentNum == 112 }"
                    class="commonBtn"
                    style="margin-top: 23px"
                  >
                    免编程功能桥接芯片
                  </div>
                  <div
                    @click="handleBtn(114, 2)"
                    :class="{ activeColor: currentNum == 114 }"
                    class="commonBtn"
                    style="margin-top: 8px"
                  >
                    接口控制芯片
                  </div>
                  <div
                    @click="handleBtn(116, 2)"
                    :class="{ activeColor: currentNum == 116 }"
                    class="commonBtn"
                    style="margin-top: 6px"
                  >
                    USB单片机
                  </div>

                  <div
                    @click="handleBtn(120, 2)"
                    :class="{ activeColor: currentNum == 120 }"
                    class="commonBtn"
                    style="margin-top: 25px"
                  >
                    接口控制芯片
                  </div>
                  <div
                    @click="handleBtn(122, 2)"
                    :class="{ activeColor: currentNum == 122 }"
                    class="commonBtn"
                    style="margin-top: 8px"
                  >
                    USB单片机
                  </div>

                  <div
                    @click="handleBtn(126, 2)"
                    :class="{ activeColor: currentNum == 126 }"
                    class="commonBtn"
                    style="margin-top: 25px"
                  >
                    USB单片机
                  </div>
                </div>
              </div>
            </div>

            <!-- 3.USB主机+设备-->
            <div>
              <div
                @click="handleBtn(129, 3)"
                :class="{ activeCenter: currentNum == 129 }"
                class="common bigTitle"
                style="
                  position: absolute;
                  bottom: 187px;
                  left: 395px;
                  border-radius: 5px;
                  width: 80px;
                  height: 64px;
                "
              >
                <div style="margin-top: 10px">USB</div>
                <div style="margin-top: 5px">主机+设备</div>
              </div>
              <div class="bottomCommon middleTitle">
                <div
                  @click="handleBtn(130, 3)"
                  :class="{ activeColor: currentNum == 130 }"
                  class="commonBtn"
                  style="line-height: 36px; margin-top: 2px"
                >
                  一个USB口复用
                </div>
                <div
                  @click="handleBtn(148, 3)"
                  :class="{ activeColor: currentNum == 148 }"
                  class="commonBtn"
                  style="margin-left: 37px; margin-top: 5px"
                >
                  一个USB主机口+一个USB设备口
                </div>
                <div
                  @click="handleBtn(154, 3)"
                  :class="{ activeColor: currentNum == 154 }"
                  class="commonBtn"
                  style="margin-left: 18px; margin-top: 5px"
                >
                  多个USB主机口+USB设备口
                </div>
              </div>
              <div style="position: absolute; bottom: 10px; left: 212px">
                <div
                  class="bottomChildCommon smallTitle"
                  style="font-size: 10px"
                >
                  <div
                    @click="handleBtn(131, 3)"
                    :class="{ activeColor: currentNum == 131 }"
                    class="commonBtn"
                    style="width: 88px"
                  >
                    接口控制芯片
                  </div>
                  <div
                    @click="handleBtn(136, 3)"
                    :class="{ activeColor: currentNum == 136 }"
                    class="commonBtn"
                    style="margin-left: 6px; width: 78px"
                  >
                    USB单片机
                  </div>
                  <div
                    @click="handleBtn(149, 3)"
                    :class="{ activeColor: currentNum == 149 }"
                    class="commonBtn"
                    style="margin-left: 12px; width: 78px"
                  >
                    USB单片机
                  </div>
                  <div
                    @click="handleBtn(155, 3)"
                    :class="{ activeColor: currentNum == 155 }"
                    class="commonBtn"
                    style="margin-left: 36px; width: 78px"
                  >
                    USB单片机
                  </div>
                </div>
              </div>
            </div>

            <!-- 4.USB设备功能 -->
            <div>
              <div
                @click="handleBtn(46, 4)"
                :class="{ activeCenter: currentNum == 46 }"
                class="common bigTitle"
                style="
                  position: absolute;
                  top: 160px;
                  left: 395px;
                  width: 80px;
                  height: 60px;
                  border-radius: 5px;
                "
              >
                <div style="margin-top: 8px">USB</div>
                <div style="margin-top: 5px">设备功能</div>
              </div>
              <div class="topCommon middleTitle">
                <div
                  @click="handleBtn(47, 4)"
                  :class="{ activeColor: currentNum == 47 }"
                  class="commonBtn"
                  style="width: 95px"
                >
                  一个USB口
                </div>
                <div
                  @click="handleBtn(81, 4)"
                  :class="{ activeColor: currentNum == 81 }"
                  class="commonBtn"
                  style="width: 98px; margin-left: 40px"
                >
                  两个USB口
                </div>
                <div
                  @click="handleBtn(85, 4)"
                  :class="{ activeColor: currentNum == 85 }"
                  class="commonBtn"
                  style="width: 98px; margin-left: 15px"
                >
                  多个USB口
                </div>
              </div>
              <div style="position: absolute; top: 2px; left: 85px">
                <div class="topChildCommon smallTitle">
                  <div
                    @click="handleBtn(48, 4)"
                    :class="{ activeColor: currentNum == 48 }"
                    class="commonBtn"
                    style="width: 120px"
                  >
                    免编程功能桥接芯片
                  </div>
                  <div
                    @click="handleBtn(61, 4)"
                    :class="{ activeColor: currentNum == 61 }"
                    class="commonBtn"
                    style="margin-left: 3px; width: 86px"
                  >
                    接口控制芯片
                  </div>
                  <div
                    @click="handleBtn(67, 4)"
                    :class="{ activeColor: currentNum == 67 }"
                    class="commonBtn"
                    style="margin-left: 8px"
                  >
                    USB单片机
                  </div>
                  <div
                    @click="handleBtn(82, 4)"
                    :class="{ activeColor: currentNum == 82 }"
                    class="commonBtn"
                    style="margin-left: 17px"
                  >
                    USB单片机
                  </div>
                  <div
                    @click="handleBtn(86, 4)"
                    :class="{ activeColor: currentNum == 86 }"
                    class="commonBtn"
                    style="margin-left: 34px"
                  >
                    USB单片机
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 底部 -->
          <div
            style="
              box-shadow: 0px 0px 5px 1px #f1f3f8;
              border-radius: 10px;
              background: #ebf5ff;
              width: 760px;
              height: 150px;
              display: flex;
              margin-top: 20px;
              font-size: 12px;
              font-weight: bold;
              margin-bottom: 10px;
            "
          >
            <div
              :class="{ activeCenter: currentNum == 166 }"
              @click="handleBtn(166, 5)"
              class="title active"
            >
              USB速度等级
              <br />
              (向下兼容)
            </div>
            <!-- 1 -->
            <div
              style="
                background: white;
                border-radius: 5px;
                width: 600px;
                border-left: none;
                display: flex;
                text-align: left;
                height: 130px;
                margin-top: 10px;
                position: relative;
              "
            >
              <img
                src="@/assets/img/arrow.png"
                style="
                  width: 10px;
                  height: 20px;
                  position: absolute;
                  z-index: 22;
                  left: -10px;
                  top: 50px;
                "
                alt=""
              />

              <div
                style="
                  width: 150px;
                  border-right: 1px solid #e6e6e6;
                  height: 102px;
                  margin: 17px auto;
                "
              >
                <div style="margin-left: 10px">
                  <div
                    @click="handleBtn(167, 5)"
                    :class="{ activeColor: currentNum == 167 }"
                    class="active"
                    style="color: #313030; font-size: 14px; cursor: pointer"
                  >
                    USB3.0超高速(SS)
                  </div>
                  <img
                    style="
                      width: 24px;
                      height: 12px;
                      margin: 8px auto;
                      margin-left: 47px;
                    "
                    src="@/assets/img/icon.png"
                    alt=""
                  />
                  <div style="margin-top: -5px">
                    <div
                      @click="handleBtn(168, 5)"
                      style="display: flex; width: 100px"
                    >
                      <div class="circle"></div>
                      <div
                        :class="{ activeColor: currentNum == 168 }"
                        class="active"
                        style="
                          border-bottom: 1px solid #747474;
                          cursor: pointer;
                          margin-top: 3px;
                          color: #696969;
                        "
                      >
                        USB单片机
                      </div>
                    </div>
                    <div
                      @click="handleBtn(202, 5)"
                      style="display: flex; width: 130px"
                    >
                      <div class="circle"></div>
                      <div
                        :class="{ activeColor: currentNum == 168 }"
                        class="active"
                        style="
                          border-bottom: 1px solid #747474;
                          cursor: pointer;
                          margin-top: 3px;
                          color: #696969;
                        "
                      >
                        USB3.0模拟开关芯片
                      </div>
                    </div>
                    <div
                      @click="handleBtn(169, 5)"
                      style="display: flex; width: 110px"
                    >
                      <div class="circle"></div>
                      <div
                        :class="{ activeColor: currentNum == 169 }"
                        class="active"
                        style="
                          border-bottom: 1px solid #747474;
                          cursor: pointer;
                          margin-top: 3px;
                          color: #696969;
                        "
                      >
                        USB3.0应用方案
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 2 -->
              <div
                style="
                  width: 210px;
                  border-right: 1px solid #e6e6e6;
                  height: 102px;
                  margin: 17px auto;
                "
              >
                <div style="margin-left: 50px">
                  <div
                    @click="handleBtn(170, 5)"
                    :class="{ activeColor: currentNum == 170 }"
                    class="active"
                    style="color: #313030; font-size: 14px; cursor: pointer"
                  >
                    USB2.0高速(HS)
                  </div>
                  <img
                    style="
                      width: 24px;
                      height: 12px;
                      margin: 8px auto;
                      margin-left: 47px;
                    "
                    src="@/assets/img/icon.png"
                    alt=""
                  />
                  <div style="margin-top: -5px">
                    <div
                      @click="handleBtn(171, 5)"
                      style="display: flex; width: 100px"
                    >
                      <div style="margin-top: 6px" class="circle"></div>
                      <div
                        :class="{ activeColor: currentNum == 171 }"
                        class="active"
                        style="
                          border-bottom: 1px solid #747474;
                          cursor: pointer;
                          color: #696969;
                        "
                      >
                        USB单片机
                      </div>
                    </div>
                    <div
                      @click="handleBtn(175, 5)"
                      style="display: flex; width: 100px"
                    >
                      <div class="circle"></div>
                      <div
                        :class="{ activeColor: currentNum == 175 }"
                        class="active"
                        style="
                          border-bottom: 1px solid #747474;
                          cursor: pointer;
                          margin-top: 3px;
                          color: #696969;
                        "
                      >
                        接口控制芯片
                      </div>
                    </div>
                    <div
                      @click="handleBtn(177, 5)"
                      style="display: flex; width: 130px"
                    >
                      <div class="circle"></div>
                      <div
                        :class="{ activeColor: currentNum == 177 }"
                        class="active"
                        style="
                          border-bottom: 1px solid #747474;
                          cursor: pointer;
                          margin-top: 3px;
                          color: #696969;
                        "
                      >
                        免编程功能桥接芯片
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 3 -->
              <div style="width: 200px; height: 102px; margin: 17px auto">
                <div style="margin-left: 50px">
                  <div
                    @click="handleBtn(178, 5)"
                    :class="{ activeColor: currentNum == 178 }"
                    class="active"
                    style="color: #313030; font-size: 14px; cursor: pointer"
                  >
                    USB2.0 全速(FS)
                  </div>
                  <img
                    style="
                      width: 24px;
                      height: 12px;
                      margin: 8px auto;
                      margin-left: 47px;
                    "
                    src="@/assets/img/icon.png"
                    alt=""
                  />
                  <div style="margin-top: -5px">
                    <div
                      @click="handleBtn(1, 5)"
                      style="display: flex; width: 100px"
                    >
                      <div style="margin-top: 6px" class="circle"></div>
                      <div
                        :class="{ activeColor: currentNum == 1 }"
                        class="active"
                        style="
                          border-bottom: 1px solid #747474;
                          cursor: pointer;
                          color: #696969;
                        "
                      >
                        ALL Chips
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// window.onscroll = function () {
//   var screenw = screen.width;
//   var contentHeight = window.height - 100;

//   window.resize = function () {
//     contentHeight = window.height - 100;
//   };
//   var oDiv = document.getElementById("leftBar");
//   var tree = document.getElementById("showTree");

//   var H = 0,
//     Y = oDiv;
//   while (Y) {
//     H += Y.offsetTop;
//     Y = Y.offsetParent;
//   }
//   window.onscroll = function () {
//     var s = document.body.scrollTop || document.documentElement.scrollTop;
//     var sH = document.body.offsetHeight;

//     if (s > H + 10) {
//       oDiv.style = "position:fixed;top:50px;z-index:999;background:white;";
//       tree.style =
//         "width: 400px;height:" +
//         contentHeight +
//         "px;overflow: auto;margin-top: 15px";
//     } else {
//       oDiv.style = "";
//       tree.style = "width: 400px;height:810px;overflow: auto;margin-top: 15px;";
//     }
//   };
// };
export default {
  components: {
  },
  data() {
    return {
      data: [
        {
          id: 1,
          name: "USB芯片",
          detail: "",
          children: [
            {
              id: 2,
              name: "USB专用功能",
              detail: "",
              children: [
                {
                  id: 203,
                  name: "USB HUB 集线器",
                  detail: "",
                  children: [
                    {
                      id: 213,
                      name: "CH634",
                      detail: "支持Type-C/PD的工业级USB3.0 HUB芯片",
                      url: "http://www.wch.cn/products/CH634.html?",
                    },
                    {
                      id: 334,
                      name: "CH319",
                      detail: "工业级超高速USB3.0隔离延长芯片，带4端口超高速USB3.0 HUB",
                      url: "http://www.wch.cn/products/CH319.html?",
                    },
                    {
                      id: 214,
                      name: "CH339",
                      detail: "工业级7端口多功能HUB芯片，PDHUB+以太网+SD读卡器+USB转SPI/JTAG/UART/I2C等",
                      url: "http://www.wch.cn/products/CH339.html?",
                    },
                    {
                      id: 335,
                      name: "CH318",
                      detail: "工业级高速USB信号隔离延长芯片，带2端口USB HUB",
                      url: "http://www.wch.cn/products/CH318.html?",
                    },
                    {
                      id: 317,
                      name: "CH338",
                      detail: "工业级7端口HUB芯片",
                      url: "http://www.wch.cn/products/CH338.html?",
                    },
                    {
                      id: 318,
                      name: "CH377A",
                      detail: "工业级3端口高速HUB+读卡器芯片",
                      url: "http://www.wch.cn/products/CH377.html?",
                    },
                    {
                      id: 204,
                      name: "CH335/4",
                      detail: "工业级4端口HUB芯片",
                      url: "http://www.wch.cn/products/CH334.html?",
                    },
                  ],
                },
                {
                  id: 308,
                  name: "USB网卡",
                  detail: "",
                  children: [
                    {
                      id: 309,
                      name: "CH397",
                      detail: "工业级USB转100Mbps以太网芯片，高集成度、低功耗",
                      url: "http://www.wch.cn/products/CH397.html",
                    },
                    {
                      id: 319,
                      name: "CH339",
                      detail: "工业级7端口多功能HUB芯片，PDHUB+以太网+SD读卡器+USB转SPI/JTAG/UART/I2C等 ",
                      url: "http://www.wch.cn/products/CH339.html",
                    },
                    {
                      id: 320,
                      name: "CH336",
                      detail: "带USB网卡的4端口HUB芯片",
                      url: "https://www.wch.cn/downloads/CH336DS1_PDF.html",
                    },
                    {
                      id: 310,
                      name: "CH337",
                      detail: "USB转10Mbps以太网芯片",
                      url: "http://www.wch.cn/products/CH337.html",
                    },
                  ],
                },
                {
                  id: 215,
                  name: "USB读卡器",
                  detail: "",
                  children: [
                    {
                      id: 216,
                      name: "CH377A",
                      detail: "工业级3端口高速HUB+读卡器芯片",
                      url: "http://www.wch.cn/products/CH377.html",
                    },
                    {
                      id: 321,
                      name: "CH377",
                      detail: "工业级高速读卡器芯片",
                      url: "https://www.wch.cn/products/CH377.html",
                    },
                    {
                      id: 322,
                      name: "CH339",
                      detail: "工业级7端口多功能HUB芯片，PDHUB+以太网+SD读卡器+USB转SPI/JTAG/UART/I2C等 ",
                      url: "http://www.wch.cn/products/CH339.html",
                    },
                  ],
                },
                {
                  id: 160,
                  name: "USB PD协议/电源类",
                  children: [
                    {
                      id: 161,
                      name: "eMarker电子标签芯片",
                      children:[
                        {
                          id: 162,
                          name: "CH251",
                          detail: "简化版USB Type-C线缆电子标签芯片",
                          url: "http://www.wch.cn/products/CH251.html",
                        },
                        {
                          id: 163,
                          name: "CH252",
                          detail: "USB Type-C线缆电子标签芯片",
                          url: "http://www.wch.cn/products/CH252.html",
                        },
                        {
                          id: 164,
                          name: "CH253",
                          detail: "高耐压USB Type-C线缆电子标签芯片",
                          url: "http://www.wch.cn/products/CH253.html",
                        },
                        {
                          id: 165,
                          name: "CH254",
                          detail: "支持温度保护的USB Type-C线缆电子标签芯片",
                          url: "http://www.wch.cn/products/CH254.html",
                        },
                      ],
                    },
                    {
                      id: 221,
                      name: "快充协议芯片",
                      children:[
                        {
                          id: 222,
                          name: "CH231/0",
                          detail: "超小封装USB PD快充协议芯片",
                          url: "http://www.wch.cn/products/CH230.html",
                        },
                        {
                          id: 222,
                          name: "CH233",
                          detail: "升级款PD快充协议芯片，电压更宽，功率更高",
                          url: "http://www.wch.cn/products/CH233.html",
                        },
                        {
                          id: 223,
                          name: "CH236/5",
                          detail: "USB PD+PPS等多快充协议芯片",
                          url: "http://www.wch.cn/products/CH236.html",
                        },
                        {
                          id: 224,
                          name: "CH237",
                          detail: "Type-A+C双口多快充协议芯片",
                          url: "http://www.wch.cn/products/CH237.html",
                        },
                        {
                          id: 225,
                          name: "CH238",
                          detail: "内置MOS的USB PD+PPS等多快充协议芯片",
                          url: "http://www.wch.cn/products/CH238.html",
                        },
                      ],
                    },
                    {
                      id: 226,
                      name: "无线充电管理芯片",
                      children:[
                        {
                          id: 227,
                          name: "CH247/6",
                          detail: "无线充电管理芯片",
                          url: "http://www.wch.cn/products/CH247.html",
                        },
                        {
                          id: 228,
                          name: "CH248",
                          detail: "无线充电专用SoC芯片",
                          url: "http://www.wch.cn/products/CH248.html",
                        },
                        {
                          id: 229,
                          name: "CH271",
                          detail: "5V全桥功率芯片",
                          url: "http://www.wch.cn/products/CH271.html",
                        },
                        {
                          id: 230,
                          name: "CH274",
                          detail: "15V全桥功率芯片",
                        },
                        {
                          id: 231,
                          name: "CH275",
                          detail: "20V全桥功率芯片",
                          url: "http://www.wch.cn/products/CH275.html",
                        },
                        {
                          id: 232,
                          name: "CH32X035",
                          detail: "多路无线充电管理方案",
                          url: "http://www.wch.cn/products/CH32X035.html",
                        },
                      ]
                    },
                    {
                      id: 233,
                      name: "受电协议芯片",
                      children:[
                        {
                          id: 234,
                          name: "CH223",
                          detail: "带I2C控制功能的PD受电芯片",
                          url: "http://www.wch.cn/products/CH223.html",
                        },
                        {
                          id: 235,
                          name: "CH224/1",
                          detail: "Type-C受电端协议芯片",
                          url: "http://www.wch.cn/products/CH224.html",
                        },
                      ]
                    },
                    {
                      id: 236,
                      name: "快充协议转发芯片",
                      children:[
                        {
                          id: 237,
                          name: "CH220",
                          detail: "USB PD快充协议转发芯片",
                          url: "http://www.wch.cn/products/CH220.html",
                        },
                      ]
                    },
                    {
                      id: 238,
                      name: "多媒体电源协议芯片",
                      children:[
                        {
                          id: 239,
                          name: "CH226/5",
                          detail: "Type-C转音频+充电芯片",
                          url:"https://www.wch.cn/application/475.html",
                        },
                        {
                          id: 240,
                          name: "CH227",
                          detail: "Type-C双向快充管理芯片，PDHUB+100W反向充电高压接口芯片",
                          url: "http://www.wch.cn/products/CH227.html",
                        },
                        {
                          id: 314,
                          name: "CH9245",
                          detail: "双Type-C接口PD协议专用SoC芯片",
                          url: "http://www.wch.cn/products/CH9245.html",
                        },
                        
                      ]
                    },
                    {
                      id: 312,
                      name: "快充线缆专用SOC芯片",
                      children:[
                        {
                          id: 313,
                          name: "CH9241",
                          detail: "用于各类一进多出快充线缆及相关应用",
                          url: "http://www.wch.cn/products/CH9241.html",
                        },
                      ]
                    },
                    {
                      id: 241,
                      name: "高压接口芯片",
                      children:[
                        {
                          id: 242,
                          name: "CH211",
                          detail: "用于MCU管理Type-C接口电源和PD信号高压扩展",
                          url: "http://www.wch.cn/products/CH211.html",
                        },
                      ]
                    },
                  ],
                },
                {
                  id: 197,
                  name: "KVM应用",
                  detail: "",
                  children: [
                    {
                      id: 217,
                      name: "CH645",
                      detail: "USB多主机多设备芯片，高速4口KVM切换",
                      url: "http://www.wch.cn/products/CH645.html",
                    },
                    {
                      id: 198,
                      name: "CH9374B",
                      detail: "4口USB KVM控制芯片",
                      url: "http://www.wch.cn/products/CH9374B.html?from=list",
                    },
                    {
                      id: 199,
                      name: "CH9350",
                      detail: "级联式8口KVM切换方案",
                      url: "http://www.wch.cn/application/392.html",
                    },
                  ],
                },
                {
                  id: 3,
                  name: "模拟键盘/鼠标/U盘/HID类设备",
                  detail: "",
                  children: [
                    {
                      id: 4,
                      name: "CH9328",
                      detail: "串口转HID键盘，实现串口数据转USB键盘数据",
                      url: "http://www.wch.cn/products/CH9328.html",
                    },
                    {
                      id: 5,
                      name: "CH9350",
                      detail: "串口转HID键盘和鼠标设备芯片",
                      url: "http://www.wch.cn/products/CH9350.html",
                    },
                    {
                      id: 6,
                      name: "CH9329",
                      detail: "串口转HID键盘或鼠标或自定义HID兼容类芯片",
                      url: "http://www.wch.cn/products/CH9329.html",
                    },
                    {
                      id: 10,
                      name: "CH9326",
                      detail: "串口转自定义HID兼容类芯片",
                      url: "http://www.wch.cn/products/CH9326.html",
                    },
                    {
                      id: 7,
                      name: "CH9374",
                      detail: "4套主机共享一套USB键鼠芯片",
                      url: "http://www.wch.cn/products/CH9374B.html",
                    },
                    {
                      id: 12,
                      name: "CH331",
                      detail: "低成本小容量U盘控制芯片",
                      url: "http://www.wch.cn/products/CH331.html?from=list",
                    },
                    {
                      id: 13,
                      name: "CH9331",
                      detail: "小容量U盘控制芯片，外加存储器实现小U盘",
                      url: "http://www.wch.cn/application/355.html",
                    },
                    {
                      id: 14,
                      name: "所有USB设备功能芯片",
                    },
                    
                  ],
                },
                //  1-1-4
                {
                  id: 15,
                  name: "模拟声卡/摄像头设备",
                  detail: "",
                  children: [
                    {
                      id: 16,
                      name: "CH569",
                      detail: "USB3.0超高速单片机，实现USB3.0各种应用",
                      url: "http://www.wch.cn/products/CH569.html",
                    },
                  ],
                },
                //  1-1-5
                {
                  id: 17,
                  name: "操作键盘/鼠标/U盘/HID类设备",
                  detail: "",
                  children: [
                    {
                      id: 18,
                      name: "CH9350",
                      detail: "双路USB键盘鼠标通讯控制转串口芯片",
                      url: "http://www.wch.cn/products/CH9350.html",
                    },
                    {
                      id: 21,
                      name: "CH376",
                      detail: "U盘和SD卡文件管理控制芯片",
                      url: "http://www.wch.cn/products/CH376.html",
                    },
                    {
                      id: 22,
                      name: "CH378",
                      detail: "高速U盘和SD卡文件管理控制芯片",
                      url: "http://www.wch.cn/products/CH378.html",
                    },
                    {
                      id: 196,
                      name: "所有USB主机功能芯片",
                    },
                    
                  ],
                },
                {
                  id: 32,
                  name: "USB延长/隔离",
                  detail: "",
                  children: [
                    {
                      id: 33,
                      name: "USB键鼠延长",
                      children: [
                        {
                          id: 34,
                          name: "CH9350",
                          detail: "键鼠数据转为串口数据进行距离扩展应用芯片",
                          url: "http://www.wch.cn/products/CH9350.html",
                        },
                      ],
                    },
                    {
                      id: 35,
                      name: "USB信号物理延长",
                      children: [
                        {
                          id: 36,
                          name: "CH315",

                          detail: "对低、全速USB信号进行隔离或延长",
                          url: "http://www.wch.cn/products/CH315.html",
                        },
                      ],
                    },
                    {
                      id: 37,
                      name: "USB协议延长",
                      children: [
                        {
                          id: 38,
                          name: "CH317",
                          detail: "由网线/光纤对USB产品实现百米/公里级延长",
                          url: "http://www.wch.cn/products/CH317.html",
                        },
                      ],
                    },
                     {
                      id: 23,
                      name: "USB隔离",
                      children: [
                        {
                          id: 220,
                          name: "CH318",
                          detail: "高速USB信号隔离延长器控制芯片",
                          url: "http://www.wch.cn/products/CH318.html",
                        },
                        {
                          id: 336,
                          name: "CH319",
                          detail: "超高速USB3.0隔离延长器控制芯片",
                          url: "http://www.wch.cn/products/CH319.html",
                        },
                      ],
                    },
                    
                  ],
                },
                //  1-1-7
                {
                  id: 24,
                  name: "USB转单串口/多串口",
                  detail: "",
                  children: [
                    {
                      id: 1171,
                      name: "USB转串口芯片选型",
                      detail: "USB设备虚拟串口转一个或多个串口芯片",
                      url: "http://special.wch.cn/zh_cn/produce/",
                    },
                  ],
                },
                //  1-1-8
                {
                  id: 25,
                  name: "USB转JTAG&SPI&I2C其他接口",
                  detail: "",
                  children: [
                    {
                      id: 26,
                      name: "CH340",
                      detail: "USB设备口转打印口芯片",
                      url: "http://www.wch.cn/products/CH340_DS2.html",
                    },
                    {
                      id: 27,
                      name: "CH341",
                      detail: "USB设备口转打印口、并口、I2C、SPI、GPIO等",
                      url: "http://www.wch.cn/products/CH341.html",
                    },
                    {
                      id: 28,
                      name: "CH345",
                      detail: "USB设备口转MIDI接口芯片",
                      url: "http://www.wch.cn/products/CH345.html",
                    },
                    {
                      id: 218,
                      name: "CH346",
                      detail: "480Mbps高速USB转并口FIFO/SPI/单串口/双串口芯片",
                      // url: "http://www.wch.cn/products/CH346.html?",
                    },
                    {
                      id: 212,
                      name: "CH347",
                      detail: "480Mbps高速USB转串口、SPI、I2C、JTAG等",
                      url: "http://www.wch.cn/products/CH347.html?",
                    },
                    {
                      id: 29,
                      name: "CH9343",
                      detail: "Android AOA转串口/I2C/SPI/PWM/GPIO等接口",
                      url: "http://www.wch.cn/products/CH9343.html",
                    },
                  ],
                },
                //  1-1-9
                {
                  id: 30,
                  name: "USB转蓝牙",
                  detail: "",
                  children: [
                    {
                      id: 31,
                      name: "CH9143",
                      detail: "蓝牙、串口和USB数据的三向互通传输芯片",
                      url: "http://www.wch.cn/products/CH9143.html",
                    },
                  ],
                },
              
                // 1-1-1-11
                {
                  id: 39,
                  name: "其他功能或方案",
                  detail: "",
                  children: [
                    {
                      id: 40,
                      name: "USB3.0超高速接口应用方案",
                      detail:
                        "USB3.0 FIFO/转千兆以太网/超高速加密U盘/高速数据流远传等应用",
                      url: "http://www.wch.cn/application/509.html",
                    },
                    {
                      id: 41,
                      name: "USB转串口方案",
                      detail:
                        "对串口数量/驱动类型/波特率/封装/电压范围等条件灵活选用",
                      url: "http://www.wch.cn/application/357.html",
                    },
                    {
                      id: 42,
                      name: "USB Android AOA转接方案",
                      detail: "Android USB接口控制方案，扩展6种接口",
                      url: "http://www.wch.cn/application/352.html",
                    },
                    {
                      id: 43,
                      name: "安卓系统USB产品选型",
                      detail: "对安卓USB产品类型/场景/特点推出单芯片方案",
                      url: "http://www.wch.cn/application/446.html",
                    },
                    {
                      id: 44,
                      name: "USB-PS2键盘/条码枪数据采集方案",
                      detail: "USB和PS2键盘/条码枪原始值采集及转移",
                      url: "http://www.wch.cn/application/431.html",
                    },
                    {
                      id: 45,
                      name: "USB打印机数据采集/管理方案",
                      detail: "针对USB小票打印机无感式原始数据采集及转移",
                      url: "http://www.wch.cn/application/369.html",
                    },
                    {
                      id: 243,
                      name: "USB转32串口应用方案",
                      detail: "HUB+USB转8串芯片实现USB转32路高速串口",
                      url: "https://www.wch.cn/application/583.html",
                    },
                    {
                      id: 244,
                      name: "USB2.0高速4口KVM切换器方案",
                      detail: "针对KVM应用优化推出单芯片高性能、差异化解决方案(上行4个口，均自带4端口USB2.0高速HUB功能)",
                      url: "https://www.wch.cn/application/649.html",
                    },
                    {
                      id: 245,
                      name: "USB设备共享/切换器方案",
                      detail: "无需物理端口插拔，按键或者软件点击实现多主机共享一个设备",
                      url: "https://www.wch.cn/application/356.html",
                    },
                    {
                      id: 245,
                      name: "USB远距离延长系列方案",
                      detail: "低成本网线实现USB信号百米以上延长，光纤线公里级距离延长",
                      url: "https://www.wch.cn/application/358.html",
                    },
                  ],
                },
              ],
            },
            {
              id: 46,
              name: "USB设备功能(device)",
              detail: "",
              children: [
                // 1-2-1
                {
                  id: 47,
                  name: "一个USB口",
                  detail: "",
                  children: [
                    {
                      id: 48,
                      name: "免编程功能桥接芯片",
                      children: [
                        {
                          id: 246,
                          name: "CH346",
                          detail: "480Mbps高速USB转并口FIFO/SPI/单串口/双串口芯片",
                        },
                        {
                          id: 247,
                          name: "CH9111",
                          detail: "高速USB转串口芯片，15Mbps波特率",
                          url: "http://www.wch.cn/products/CH9111.html",
                        },
                        {
                          id: 248,
                          name: "CH347",
                          detail: "高速USB转JTAG/SWD/SPI/I2C/串口芯片",
                          url: "http://www.wch.cn/products/CH347.html",
                        },
                        {
                          id: 49,
                          name: "CH343",
                          detail: "第3代USB转高速异步串口芯片",
                          url: "http://www.wch.cn/products/CH343.html",
                        },
                        {
                          id: 50,
                          name: "CH9102",
                          detail: "第3代USB转异步串口芯片",
                          url: "http://www.wch.cn/products/CH9102.html",
                        },
                        {
                          id: 311,
                          name: "CH9101",
                          detail: "第3代USB转异步串口芯片",
                          url: "http://www.wch.cn/products/CH9101.html",
                        },
                        {
                          id: 51,
                          name: "CH341",
                          detail: "USB转串口/打印口/I2C/SPI等接口芯片",
                          url: "http://www.wch.cn/products/CH341.html",
                        },
                        {
                          id: 52,
                          name: "CH340",
                          detail: "经典USB转串口芯片",
                          url: "http://www.wch.cn/products/CH340.html",
                        },
                        {
                          id: 249,
                          name: "CH9143",
                          detail: "USB、串口、BLE接口三通芯片",
                          url: "http://www.wch.cn/products/CH9143.html",
                        },
                        {
                          id: 250,
                          name: "CH9103",
                          detail: "USB转高速双串口芯片",
                          url: "http://www.wch.cn/products/CH9103.html",
                        },
                        {
                          id: 251,
                          name: "CH344",
                          detail: "高速USB转四串口芯片",
                          url: "http://www.wch.cn/products/CH344.html",
                        },
                        {
                          id: 252,
                          name: "CH9114",
                          detail: "高速USB转四串口芯片，15Mbps波特率",
                          url: "http://www.wch.cn/products/CH9114.html",
                        },
                        {
                          id: 53,
                          name: "CH9326",
                          detail: "USB HID类转串口芯片",
                          url: "http://www.wch.cn/products/CH9326.html",
                        },

                        {
                          id: 54,
                          name: "CH9340",
                          detail: "USB CDC类转串口芯片",
                          url: "http://www.wch.cn/products/CH9340.html",
                        },
                        {
                          id: 55,
                          name: "CH342",
                          detail: "USB转双串口芯片",
                          url: "http://www.wch.cn/products/CH342.html",
                        },
                        {
                          id: 56,
                          name: "CH9344",
                          detail: "高速USB转4串口芯片",
                          url: "http://www.wch.cn/products/CH9344.html",
                        },
                        {
                          id: 253,
                          name: "CH9104",
                          detail: "USB转四串口芯片",
                          url: "http://www.wch.cn/products/CH9104.html",
                        },
                        {
                          id: 254,
                          name: "CH348",
                          detail: "高速USB转八串口芯片",
                          url: "http://www.wch.cn/products/CH348.html",
                        },
                        {
                          id: 255,
                          name: "CH377",
                          detail: "工业级3端口高速HUB+读卡器芯片",
                          url: "http://www.wch.cn/products/CH377.html",
                        },
                        {
                          id: 256,
                          name: "CH345",
                          detail: "USB转MIDI芯片 ",
                          url: "http://www.wch.cn/products/CH345.html",
                        },
                        {
                          id: 57,
                          name: "CH9329",
                          detail: "串口转HID键盘或鼠标或自定义HID兼容类芯片",
                          url: "http://www.wch.cn/products/CH9329.html",
                        },
                        {
                          id: 58,
                          name: "CH9328",
                          detail: "串口转HID键盘，实现串口数据转USB键盘数据",
                          url: "http://www.wch.cn/products/CH9328.html",
                        },
                        {
                          id: 59,
                          name: "CH9350",
                          detail: "串口转USB键盘和鼠标设备芯片",
                          url: "http://www.wch.cn/products/CH9350.html",
                        },
                        {
                          id: 60,
                          name: "CH331",
                          detail: "低成本小U盘模拟芯片",
                          url: "http://www.wch.cn/products/CH331.html",
                        },
                      ],
                    },
                    {
                      id: 61,
                      name: "接口控制芯片",
                      children: [
                        {
                          id: 62,
                          name: "CH372",
                          detail: "USB全速设备接口芯片，并口驱动",
                          url: "http://www.wch.cn/products/CH372.html",
                        },
                        {
                          id: 63,
                          name: "CH374",
                          detail: "USB全速设备接口芯片，并口/SPI驱动",
                          url: "http://www.wch.cn/products/CH374.html",
                        },
                        {
                          id: 64,
                          name: "CH375",
                          detail: "USB全速设备接口芯片，并口驱动",
                          url: "http://www.wch.cn/products/CH375.html",
                        },
                        {
                          id: 65,
                          name: "CH376",
                          detail: "USB全速设备接口芯片，并口/SPI驱动",
                          url: "http://www.wch.cn/products/CH376.html",
                        },
                        {
                          id: 66,
                          name: "CH378",
                          detail: "USB高速设备接口芯片，并口/SPI/串口驱动",
                          url: "http://www.wch.cn/products/CH378.html",
                        },
                      ],
                    },
                    {
                      id: 67,
                      name: "USB单片机",
                      children: [
                        {
                          id: 257,
                          name: "CH32M030",
                          detail: "RISC-V，USB主从电机控制MCU",
                          url: "http://www.wch.cn/products/CH32M030.html",
                        },
                        {
                          id: 258,
                          name: "CH32X035",
                          detail: "RISC-V，USB主从PDUSBMCU",
                          url: "http://www.wch.cn/products/CH32X035.html",
                        },
                        {
                          id: 259,
                          name: "CH32L103",
                          detail: "RISC-V，USB主从PDUSB低功耗MCU",
                          url: "http://www.wch.cn/products/CH32L103.html",
                        },
                        {
                          id: 69,
                          name: "CH32V103",
                          detail: "RISC-V，USB主从增强型通用MCU",
                          url: "http://www.wch.cn/products/CH32V103.html",
                        },
                        {
                          id: 260,
                          name: "CH32V303",
                          detail: "RISC-V，USB主从大容量通用MCU",
                          url: "http://www.wch.cn/products/CH32V303.html",
                        },
                        {
                          id: 205,
                          name: "CH32V307",
                          detail: " USB高速主从+USB全速主从/以太网/八串口",
                          url: "http://www.wch.cn/products/CH32V307.html?",
                        },
                        {
                          id: 261,
                          name: "CH584",
                          detail: "RISC-V，USB主从/蓝牙MCU",
                          url: "http://www.wch.cn/products/CH585.html?",
                        },
                        {
                          id: 262,
                          name: "CH592",
                          detail: "RISC-V，USB主从/蓝牙低功耗MCU，段式LCD",
                          url: "http://www.wch.cn/products/CH592.html",
                        },
                        {
                          id: 70,
                          name: "CH569/565",
                          detail: "RISC-V，USB3.0超高速主从接口通用MCU",
                          url: "http://www.wch.cn/products/CH569.html",
                        },
                        {
                          id: 71,
                          name: "CH568/567",
                          detail: "USB高速主从/SATA/SD/加密型MCU",
                          url: "http://www.wch.cn/products/CH568.html",
                        },
                        {
                          id: 263,
                          name: "CH564",
                          detail: "RISC-V，USB高速主从/以太网通用MCU",
                          url: "http://www.wch.cn/products/CH564.html",
                        },
                        {
                          id: 72,
                          name: "CH563",
                          detail: "ARM，USB高速主从/以太网通用MCU",
                          url: "http://www.wch.cn/products/CH563.html",
                        },
                        {
                          id: 73,
                          name: "CH579/578",
                          detail: "Cortex-M0，USB主从/以太网/蓝牙低功耗MCU",
                          url: "http://www.wch.cn/products/CH579.html",
                        },

                        {
                          id: 74,
                          name: "CH573",
                          detail: "RISC-V，USB主从/蓝牙低功耗MCU",
                          url: "http://www.wch.cn/products/CH573.html",
                        },
                        {
                          id: 76,
                          name: "CH559",
                          detail: "E8051增强型USB主从MCU",
                          url: "http://www.wch.cn/products/CH559.html",
                        },
                        {
                          id: 191,
                          name: "CH558",
                          detail: "E8051增强型USB设备MCU",
                          url: "http://www.wch.cn/products/CH558.html",
                        },
                        {
                          id: 192,
                          name: "CH557",
                          detail: "E8051增强型USB设备+4路USB主机MCU",
                          url: "http://www.wch.cn/products/CH557.html",
                        },

                        {
                          id: 77,
                          name: "CH549/548",
                          detail: "E8051增强型USB主从MCU",
                          url: "http://www.wch.cn/products/CH549.html",
                        },
                        {
                          id: 193,
                          name: "CH547/546",
                          detail: "E8051增强型USB设备MCU",
                          url: "http://www.wch.cn/products/CH547.html",
                        },
                        {
                          id: 78,
                          name: "CH554",
                          detail: "E8051增强型USB主从MCU",
                          url: "http://www.wch.cn/products/CH554.html",
                        },
                        {
                          id: 79,
                          name: "CH552/551",
                          detail: "E8051增强型USB设备MCU",
                          url: "http://www.wch.cn/products/CH552.html",
                        },
                        {
                          id: 80,
                          name: "CH539/533",
                          detail: "USB主从基础型MCU，汇编方式",
                        },
                        
                      ],
                    },
                  ],
                },
                // 1-2-2
                {
                  id: 81,
                  name: "两个USB口",
                  children: [
                    {
                      id: 82,
                      name: "USB单片机",
                      children: [
                        {
                          id: 264,
                          name: "CH32V203",
                          detail: "双USB主从增强型低功耗MCU",
                          url: "http://www.wch.cn/products/CH32V203.html",
                        },
                        {
                          id: 265,
                          name: "CH32V208",
                          detail: "双USB主从无线型MCU",
                          url: "http://www.wch.cn/products/CH32V208.html",
                        },
                        {
                          id: 266,
                          name: "CH32V305",
                          detail: "USB高速主从+USB全速主从互联型MCU",
                          url: "http://www.wch.cn/products/CH32V307.html",
                        },
                        {
                          id: 206,
                          name: "CH32V317/307",
                          detail: "USB高速主从+USB全速主从/以太网/八串口",
                          url: "http://www.wch.cn/products/CH32V317.html?",
                        },
                        {
                          id: 267,
                          name: "CH585",
                          detail: "USB高速主从+USB全速主从/蓝牙MCU，NFC+段式LCD",
                          url: "http://www.wch.cn/products/CH585.html",
                        },
                        {
                          id: 268,
                          name: "CH583/582",
                          detail: "双USB主从/蓝牙MCU",
                          url: "http://www.wch.cn/products/CH583.html",
                        },
                        {
                          id: 84,
                          name: "CH567",
                          detail: "双USB2.0高速接口/SD/加密型MCU",
                          url: "http://www.wch.cn/products/CH567.html",
                        },
                        
                      ],
                    },
                  ],
                },
                // 1-2-3
                {
                  id: 85,
                  name: "多个USB口",
                  children: [
                    {
                      id: 86,
                      name: "USB单片机",
                      children: [
                        {
                          id: 269,
                          name: "CH645",
                          detail: "8路主机+28路设备/双Type-C PD/以太网多接口MCU",
                          url: "http://www.wch.cn/products/CH645.html",
                        },
                        {
                          id: 87,
                          name: "CH545",
                          detail: "4路USB主机+17路USB设备增强型MCU",
                          url: "http://www.wch.cn/products/CH545.html",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              id: 88,
              name: "USB主机功能(host)",
              detail: "",
              children: [
                // 1-3-1
                {
                  id: 89,
                  name: "一个USB口",
                  children: [
                    {
                      id: 90,
                      name: "免编程功能桥接芯片",
                      children: [
                        {
                          id: 91,
                          name: "CH9350",
                          detail: "双路USB键盘鼠标通讯控制转串口芯片",
                          url: "http://www.wch.cn/products/CH9350.html",
                        },
                        {
                          id: 92,
                          name: "CH9343",
                          detail: "Android AOA转串口/I2C/SPI/PWM等接口芯片",
                          url: "http://www.wch.cn/products/CH9343.html",
                        },
                      ],
                    },
                    {
                      id: 93,
                      name: "接口控制芯片",
                      children: [
                        {
                          id: 94,
                          name: "CH370",
                          detail: "USB全速主机接口芯片，并口/SPI驱动",
                          url: "http://www.wch.cn/products/CH370.html",
                        },
                        {
                          id: 95,
                          name: "CH374",
                          detail: "USB全速3路主机接口芯片，并口/SPI驱动",
                          url: "http://www.wch.cn/products/CH374.html",
                        },
                        {
                          id: 96,
                          name: "CH375",
                          detail: "USB全速主机接口芯片，并口/串口驱动",
                          url: "http://www.wch.cn/products/CH375.html",
                        },
                        {
                          id: 97,
                          name: "CH376",
                          detail: "U盘/SD卡文件管理芯片，并口/SPI/串口驱动",
                          url: "http://www.wch.cn/products/CH376.html",
                        },
                        {
                          id: 98,
                          name: "CH378",
                          detail: "高速U盘/SD卡文件管理芯片",
                          url: "http://www.wch.cn/products/CH378.html",
                        },
                      ],
                    },
                    {
                      id: 99,
                      name: "USB单片机",
                      children: [
                        {
                          id: 270,
                          name: "CH32M030",
                          detail: "RISC-V，USB主从电机控制MCU",
                          url: "http://www.wch.cn/products/CH32M030.html",
                        },
                        {
                          id: 271,
                          name: "CH32X035",
                          detail: "RISC-V，USB主从PDUSB MCU",
                          url: "http://www.wch.cn/products/CH32X035.html",
                        },
                        {
                          id: 272,
                          name: "CH32L103",
                          detail: "RISC-V，USB主从PDUSB低功耗 MCU",
                          url: "http://www.wch.cn/products/CH32L103.html",
                        },
                        {
                          id: 101,
                          name: "CH32V103",
                          detail: "RISC-V，USB主从增强型通用MCU",
                          url: "http://www.wch.cn/products/CH32V103.html",
                        },
                        {
                          id: 273,
                          name: "CH32V303",
                          detail: "RISC-V，USB主从大容量通用MCU",
                          url: "http://www.wch.cn/products/CH32V303.html",
                        },
                        {
                          id: 207,
                          name: "CH32V307",
                          detail: "USB高速主从+USB全速主从/以太网/八串口",
                          url: "http://www.wch.cn/products/CH32V307.html?",
                        },
                        {
                          id: 315,
                          name: "CH584",
                          detail: "RISC-V，USB主从/蓝牙MCU",
                          url: "http://www.wch.cn/products/CH585.html?",
                        },
                        {
                          id: 316,
                          name: "CH592",
                          detail: "RISC-V，USB主从/蓝牙低功耗MCU，段式LCD",
                          url: "http://www.wch.cn/products/CH592.html?",
                        },
                        {
                          id: 102,
                          name: "CH569/565",
                          detail: "RISC-V，USB3.0超高速主从接口通用MCU",
                          url: "http:/www.wch.cn/products/CH569.html",
                        },
                        {
                          id: 103,
                          name: "CH568/567",
                          detail: "USB高速主从/SATA/SD/加密型MCU",
                          url: "http://www.wch.cn/products/CH568.html",
                        },
                        {
                          id: 274,
                          name: "CH564",
                          detail: "RISC-V，USB高速主从/以太网通用MCU",
                          url: "http://www.wch.cn/products/CH564.html",
                        },
                        {
                          id: 104,
                          name: "CH563",
                          detail: "ARM架构，USB高速主从/以太网通用MCU",
                          url: "http://www.wch.cn/products/CH563.html",
                        },
                        {
                          id: 105,
                          name: "CH579/578",
                          detail: "Cortex-M0，USB主从/以太网/蓝牙低功耗MCU",
                          url: "http://www.wch.cn/products/CH579.html",
                        },
                        {
                          id: 106,
                          name: "CH573",
                          detail: "RISC-V，USB主从/蓝牙低功耗MCU",
                          url: "http://www.wch.cn/products/CH573.html",
                        },
                        {
                          id: 107,
                          name: "CH559",
                          detail: "E8051增强型USB双主机口MCU",
                          url: "http://www.wch.cn/products/CH559.html",
                        },
                        {
                          id: 108,
                          name: "CH549/548",
                          detail: "E8051增强型USB主从MCU",
                          url: "http://www.wch.cn/products/CH549.html",
                        },
                        {
                          id: 109,
                          name: "CH554",
                          detail: "E8051增强型USB主从MCU",
                          url: "http://www.wch.cn/products/CH554.html",
                        },
                        {
                          id: 110,
                          name: "CH539/533",
                          detail: "USB主从基础型MCU，汇编方式",
                        },
                        
                      ],
                    },
                  ],
                },
                // 1-3-2
                {
                  id: 111,
                  name: "两个USB口",
                  children: [
                    {
                      id: 112,
                      name: "免编程功能桥接芯片",
                      children: [
                        {
                          id: 113,
                          name: "CH9350",
                          detail: "双路USB键盘鼠标通讯控制转串口芯片",
                          url: "http://www.wch.cn/products/CH9350.html",
                        },
                      ],
                    },
                    {
                      id: 114,
                      name: "接口控制芯片",
                      children: [
                        {
                          id: 115,
                          name: "CH374",
                          detail: "USB全速3路主机接口芯片，并口/SPI驱动",
                          url: "http://www.wch.cn/products/CH374.html",
                        },
                      ],
                    },
                    {
                      id: 116,
                      name: "USB单片机",
                      children: [
                        {
                          id: 275,
                          name: "CH32V203",
                          detail: "双USB主从增强型低功耗MCU",
                          url: "http://www.wch.cn/products/CH32V203.html",
                        },
                        {
                          id: 276,
                          name: "CH32V208",
                          detail: "双USB主从无线型MCU",
                          url: "http://www.wch.cn/products/CH32V208.html",
                        },
                        {
                          id: 277,
                          name: "CH32V305",
                          detail: "USB高速主从+USB全速主从互联型MCU",
                          url: "http://www.wch.cn/products/CH32V307.html",
                        },
                        {
                          id: 208,
                          name: "CH32V317/307",
                          detail: "USB高速主从+USB全速主从/以太网/八串口",
                          url: "http://www.wch.cn/products/CH32V317.html?",
                        },
                        {
                          id: 278,
                          name: "CH585",
                          detail: "USB高速主从+USB全速主从/蓝牙MCU，NFC+段式LCD",
                          url: "http://www.wch.cn/products/CH585.html",
                        },
                        {
                          id: 279,
                          name: "CH583/582",
                          detail: "双USB主从/蓝牙MCU",
                          url: "http://www.wch.cn/products/CH583.html",
                        },
                        {
                          id: 117,
                          name: "CH567",
                          detail: "双USB高速接口/SD/加密型MCU",
                          url: "http://www.wch.cn/products/CH567.html",
                        },
                        {
                          id: 118,
                          name: "CH559",
                          detail: "E8051增强型USB双主机口MCU",
                          url: "http://www.wch.cn/products/CH559.html",
                        },
                        {
                          id: 194,
                          name: "CH557",
                          detail: "E8051增强型4路USB主机+USB设备MCU",
                          url: "http://www.wch.cn/products/CH557.html",
                        },
                        {
                          id: 195,
                          name: "CH545",
                          detail: "4路USB主机+17路USB设备增强型MCU",
                          url: "http://www.wch.cn/products/CH545.html",
                        },
                        
                      ],
                    },
                  ],
                },
                // 1-3-3
                {
                  id: 119,
                  name: "三个USB口",
                  children: [
                    {
                      id: 120,
                      name: "接口控制芯片",
                      children: [
                        {
                          id: 121,
                          name: "CH374",
                          detail: "USB全速3路主机接口芯片，并口/SPI驱动",
                          url: "http://www.wch.cn/products/CH374.html",
                        },
                      ],
                    },
                    {
                      id: 122,
                      name: "USB单片机",
                      children: [
                        {
                          id: 280,
                          name: "CH645",
                          detail: "8路主机+28路设备/双Type-C PD/以太网多接口MCU",
                          url: "http://www.wch.cn/products/CH645.html",
                        },
                        {
                          id: 123,
                          name: "CH557",
                          detail: "E8051增强型4路USB主机+USB设备MCU",
                          url: "http://www.wch.cn/products/CH557.html",
                        },
                        {
                          id: 124,
                          name: "CH545",
                          detail: "4路USB主机+17路USB设备增强型MCU",
                          url: "http://www.wch.cn/products/CH545.html",
                        },
                      ],
                    },
                  ],
                },
                // 1-3-4
                {
                  id: 125,
                  name: "四个USB口以上",
                  children: [
                    {
                      id: 126,
                      name: "USB单片机",
                      children: [
                        {
                          id: 281,
                          name: "CH645",
                          detail: "8路主机+28路设备/双Type-C PD/以太网多接口MCU",
                          url: "http://www.wch.cn/products/CH645.html",
                        },
                        {
                          id: 127,
                          name: "CH557",
                          detail: "E8051增强型4路USB主机+USB设备MCU",
                          url: "http://www.wch.cn/products/CH557.html",
                        },
                        {
                          id: 128,
                          name: "CH545",
                          detail: "4路USB主机+17路USB设备增强型MCU",
                          url: "http://www.wch.cn/products/CH545.html",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              id: 129,
              name: "USB主机+设备(OTG)",
              detail: "",
              children: [
                {
                  id: 130,
                  name: "一个USB口复用",
                  children: [
                    {
                      id: 131,
                      name: "接口控制芯片",
                      children: [
                        {
                          id: 132,
                          name: "CH374",
                          detail: "USB全速主从接口芯片，并口/SPI驱动",
                          url: "http://www.wch.cn/products/CH374.html",
                        },
                        {
                          id: 133,
                          name: "CH375",
                          detail: "USB全速主从接口芯片，并口/串口驱动",
                          url: "http://www.wch.cn/products/CH375.html",
                        },
                        {
                          id: 134,
                          name: "CH376",
                          detail: "U盘/SD卡文件管理芯片，并口/SPI/串口驱动",
                          url: "http://www.wch.cn/products/CH376.html",
                        },
                        {
                          id: 135,
                          name: "CH378",
                          detail: "USB高速主从接口芯片，高速U盘/SD卡文件管理",
                          url: "http://www.wch.cn/products/CH378.html",
                        },
                      ],
                    },
                    {
                      id: 136,
                      name: " USB单片机",
                      children: [
                        {
                          id: 282,
                          name: "CH32M030",
                          detail: "RISC-V，USB主从电机控制MCU",
                          url: "http://www.wch.cn/products/CH32M030.html",
                        },
                        {
                          id: 283,
                          name: "CH32X035",
                          detail: "RISC-V，USB主从PDUSB MCU",
                          url: "http://www.wch.cn/products/CH32X035.html",
                        },
                        {
                          id: 284,
                          name: "CH32L103",
                          detail: "RISC-V，USB主从PDUSB低功耗 MCU",
                          url: "http://www.wch.cn/products/CH32L103.html",
                        },
                        {
                          id: 138,
                          name: "CH32V103",
                          detail: "RISC-V，USB主从增强型通用MCU",
                          url: "http://www.wch.cn/products/CH32V103.html",
                        },
                        {
                          id: 285,
                          name: "CH32V303",
                          detail: "RISC-V，USB主从大容量通用MCU",
                          url: "http://www.wch.cn/products/CH32V303.html",
                        },
                        {
                          id: 209,
                          name: "CH32V317/307",
                          detail: "USB高速主从+USB全速主从/以太网/八串口",
                          url: "http://www.wch.cn/products/CH32V317.html?",
                        },
                        {
                          id: 286,
                          name: "CH584",
                          detail: "RISC-V，USB主从/蓝牙MCU",
                          url: "http://www.wch.cn/products/CH585.html",
                        },
                        {
                          id: 287,
                          name: "CH592",
                          detail: "RISC-V，USB主从/蓝牙低功耗MCU，段式LCD",
                          url: "http://www.wch.cn/products/CH592.html",
                        },
                        {
                          id: 139,
                          name: "CH569/565",
                          detail: "RISC-V，USB3.0超高速主从接口通用MCU",
                          url: "http://www.wch.cn/products/CH569.html",
                        },
                        {
                          id: 140,
                          name: "CH568/567",
                          detail: "USB高速主从/SATA/SD/加密型MCU",
                          url: "http://www.wch.cn/products/CH568.html",
                        },
                        {
                          id: 288,
                          name: "CH564",
                          detail: "RISC-V，USB高速主从/以太网通用MCU",
                          url: "http://www.wch.cn/products/CH564.html",
                        },
                        {
                          id: 141,
                          name: "CH563",
                          detail: "ARM，USB高速主从/以太网通用MCU",
                          url: "http://www.wch.cn/products/CH563.html",
                        },

                        {
                          id: 142,
                          name: "CH579/578",
                          detail: "Cortex-M0，USB主从/以太网/蓝牙低功耗MCU",
                          url: "http://www.wch.cn/products/CH579.html",
                        },
                        {
                          id: 143,
                          name: "CH573",
                          detail: "RISC-V，USB主从/蓝牙低功耗MCU",
                          url: "http://www.wch.cn/products/CH573.html",
                        },
                        {
                          id: 144,
                          name: "CH559",
                          detail: "E8051增强型USB主从MCU",
                          url: "http://www.wch.cn/products/CH559.html",
                        },
                        {
                          id: 145,
                          name: "CH549/548",
                          detail: "E8051增强型USB主从MCU",
                          url: "http://www.wch.cn/products/CH549.html",
                        },
                        {
                          id: 146,
                          name: "CH554",
                          detail: "E8051增强型USB主从MCU",
                          url: "http://www.wch.cn/products/CH554.html",
                        },
                        {
                          id: 147,
                          name: "CH539/533",
                          detail: "USB主从基础型MCU，汇编方式",
                        },
                        
                      ],
                    },
                  ],
                },
                {
                  id: 148,
                  name: "一个USB主机口+一个USB设备口",
                  children: [
                    {
                      id: 149,
                      name: " USB单片机",
                      children: [
                        {
                          id: 289,
                          name: "CH32V203",
                          detail: "双USB主从增强型低功耗MCU",
                          url: "http://www.wch.cn/products/CH32V203.html",
                        },
                        {
                          id: 290,
                          name: "CH32V208",
                          detail: "双USB主从无线型MCU",
                          url: "http://www.wch.cn/products/CH32V208.html",
                        },
                        {
                          id: 291,
                          name: "CH32V305",
                          detail: "USB高速主从+USB全速主从互联型MCU",
                          url: "http://www.wch.cn/products/CH32V307.html",
                        },
                        {
                          id: 292,
                          name: "CH32V317/307",
                          detail: "USB高速主从+USB全速主从/以太网/八串口",
                          url: "http://www.wch.cn/products/CH32V317.html",
                        },
                        {
                          id: 293,
                          name: "CH585",
                          detail: "USB高速主从+USB全速主从/蓝牙MCU，NFC+段式LCD",
                          url: "http://www.wch.cn/products/CH585.html",
                        },
                        {
                          id: 294,
                          name: "CH583/582",
                          detail: "双USB主从/蓝牙MCU",
                          url: "http://www.wch.cn/products/CH583.html",
                        },
                        {
                          id: 151,
                          name: "CH567",
                          detail: "双USB高速接口/SD/加密型MCU",
                          url: "http://www.wch.cn/products/CH567.html",
                        },
                        {
                          id: 152,
                          name: "CH557",
                          detail: "E8051增强型4路USB主机+USB设备MCU",
                          url: "http://www.wch.cn/products/CH557.html",
                        },
                        {
                          id: 153,
                          name: "CH545",
                          detail: "4路USB主机+17路USB设备增强型MCU",
                          url: "http://www.wch.cn/products/CH545.html",
                        },
                      ],
                    },
                  ],
                },
                {
                  id: 154,
                  name: "多个USB主机口+USB设备口",
                  children: [
                    {
                      id: 155,
                      name: " USB单片机",
                      children: [
                        {
                          id: 295,
                          name: "CH645",
                          detail: "8路主机+28路设备/双Type-C PD/以太网多接口MCU",
                          url: "http://www.wch.cn/products/CH645.html",
                        },
                        {
                          id: 156,
                          name: "CH557",
                          detail: "E8051增强型4路USB主机+USB设备MCU",
                          url: "http://www.wch.cn/products/CH557.html",
                        },
                        {
                          id: 157,
                          name: "CH545",
                          detail: "4路USB主机+17路USB设备增强型MCU",
                          url: "http://www.wch.cn/products/CH545.html",
                        },
                        {
                          id: 158,
                          name: "CH9372/9374",
                          detail: "多口KVM芯片",
                          url: "http://www.wch.cn/application/392.html",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        //  第三行
        {
          id: 166,
          name: "USB速度等级(向下兼容)",
          detail: "",
          children: [
            {
              id: 167,
              name: "USB3.0 超高速(SS)",
              children: [
                {
                  id: 168,
                  name: "USB单片机",
                  children: [
                    {
                      id: 180,
                      name: "CH569",
                      detail: "USB3.0 OTG+高速并口+SerDes+千兆以太网，RISC-V",
                      url: "http://www.wch.cn/products/CH569.html",
                    },
                    {
                      id: 199,
                      name: "CH565",
                      detail: "USB3.0 OTG+DVP+SerDes+千兆以太网，RISC-V",
                      url: "http://www.wch.cn/products/CH569.html",
                    },
                  ],
                },
                {
                  id: 296,
                  name: "工业级USB3.0 HUB",
                  url: "http://www.wch.cn/products/CH634.html",
                },
                {
                  id: 202,
                  name: "USB3.0模拟开关芯片",
                  url: "https://www.wch.cn/products/CH482_3_4_1_6.html",
                  // detail:"USB3.0 FIFO/转千兆以太网/超高速加密U盘/高速数据流远传等应用"
                },
                {
                  id: 169,
                  name: "USB3.0超高速接口应用方案",
                  url: "http://www.wch.cn/application/509.html",
                  detail:
                    "USB3.0 FIFO/转千兆以太网/超高速加密U盘/高速数据流远传等应用",
                },
              ],
            },
            {
              id: 170,
              name: "USB2.0 高速(HS)",
              children: [
                {
                  id: 171,
                  name: "USB单片机",
                  children: [
                    {
                      id: 297,
                      name: "CH645",
                      detail: "8路主机+28路设备/双Type-C PD/以太网多接口MCU",
                      url: "http://www.wch.cn/products/CH645.html",
                    },
                    {
                      id: 298,
                      name: "CH585",
                      detail: "USB高速主从+USB全速主从/蓝牙MCU，NFC+段式LCD",
                      url: "http://www.wch.cn/products/CH585.html",
                    },
                    {
                      id: 172,
                      name: "CH568",
                      detail: "USB高速主从/SATA/SD/加密型MCU",
                      url: "http://www.wch.cn/products/CH568.html",
                    },
                    {
                      id: 173,
                      name: "CH567",
                      detail: "双USB高速主从/SD/加密型MCU",
                      url: "http://www.wch.cn/products/CH567.html",
                    },
                    {
                      id: 299,
                      name: "CH564",
                      detail: "RISC-V，USB高速主从/以太网通用MCU",
                      url: "http://www.wch.cn/products/CH564.html",
                    },
                    {
                      id: 174,
                      name: "CH563",
                      detail: "ARM，USB高速主从/以太网通用MCU",
                      url: "http://www.wch.cn/products/CH563.html",
                    },
                    {
                      id: 300,
                      name: "CH32V305",
                      detail: "USB高速主从+USB全速主从互联型MCU",
                      url: "http://www.wch.cn/products/CH32V307.html",
                    },
                    {
                      id: 211,
                      name: "CH32V317/307",
                      detail: "USB高速主从+USB全速主从/以太网/八串口",
                      url: "http://www.wch.cn/products/CH32V317.html?",
                    },
                  ],
                },
                {
                  id: 175,
                  name: "接口控制芯片",
                  children: [
                    {
                      id: 176,
                      name: "CH378",
                      detail:
                        "USB高速主从芯片，U盘/SD卡文件管理，并口/SPI/串口驱动",
                      url: "http://www.wch.cn/products/CH378.html",
                    },
                  ],
                },
                {
                  id: 177,
                  name: "免编程功能桥接芯片",
                  children: [
                    {
                      id: 301,
                      name: "CH344",
                      detail: "高速USB转四串口芯片",
                      url: "http://www.wch.cn/products/CH344.html",
                    },
                    {
                      id: 302,
                      name: "CH346",
                      detail: "480Mbps高速USB转并口FIFO/SPI/单串口/双串口芯片",
                    },
                    {
                      id: 303,
                      name: "CH347",
                      detail: "高速USB转JTAG/SWD/SPI/I2C/串口芯片",
                      url: "http://www.wch.cn/products/CH347.html",
                    },
                    {
                      id: 304,
                      name: "CH348",
                      detail: "高速USB转八串口芯片",
                      url: "http://www.wch.cn/products/CH348.html",
                    },
                    {
                      id: 305,
                      name: "CH377",
                      detail: "工业级3端口高速HUB+读卡器芯片",
                      url: "http://www.wch.cn/products/CH377.html",
                    },
                    {
                      id: 306,
                      name: "CH9111",
                      detail: "高速USB转串口芯片，15Mbps波特率",
                      url: "http://www.wch.cn/products/CH9111.html",
                    },
                    {
                      id: 307,
                      name: "CH9114",
                      detail: "高速USB转四串口芯片，15Mbps波特率",
                      url: "http://www.wch.cn/products/CH9114.html",
                    },
                    {
                      id: 200,
                      name: "CH9344",
                      detail: "USB高速转4串口芯片",
                      url: "http://www.wch.cn/products/CH9344.html",
                    },
                  ],
                },
              ],
            },
            {
              id: 178,
              name: "USB2.0 全速(FS)",
              children: [
                {
                  id: 179,
                  name: "ALL Chips",
                },
              ],
            },
          ],
        },
      ],
      defaultProps: {
        children: "children",
        label: "name",
      },
      filterText: "",
      currentKey: "",
      currentNode: "",
      treeKey: "1",
      currentNum: 0,
      expandKeys: [1, 166, 8],
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  computed: {
  },
  mounted(){
  },
  beforeDestroy() {
  },
  methods: {
    //移入
    showTreeMouseenter(){
      this.$refs.showTree.style.overflow = 'auto'
    },
    //移出
    showTreeMouseleave(){
      this.$refs.showTree.style.overflow = 'hidden'
    },




    clickBaner() {
      window.location.href = "http://www.wch.cn";
    },
    changeValue(val) {
      this.$refs.tree.filter(val);
      if (!val) {
        this.currentNum = 0;
      }
    },
    filterNode(value, data, node) {
      // 如果共有四级菜单
      if (!value) {
        this.$refs.tree.setCurrentKey();
        return true;
      }
      if (
        this.$refs.tree.getCurrentKey() &&
        this.$refs.tree.getCurrentKey() != 178
      ) {
        let currentKey = this.$refs.tree.getCurrentKey();

        let ifOne =
          data.name.toLowerCase().indexOf(value.toLowerCase()) !== -1 &&
          data.id == currentKey;
        let ifTwo =
          node.parent &&
          node.parent.data &&
          node.parent.data.name &&
          node.parent.data.name.toLowerCase().indexOf(value.toLowerCase()) !==
            -1 &&
          node.parent.data.id == currentKey;

        let ifThree =
          node.parent &&
          node.parent.parent &&
          node.parent.parent.data &&
          node.parent.parent.data.name &&
          node.parent.parent.data.name
            .toLowerCase()
            .indexOf(value.toLowerCase()) !== -1 &&
          node.parent.parent.data.id == currentKey;

        let ifFour =
          node.parent &&
          node.parent.parent &&
          node.parent.parent.parent &&
          node.parent.parent.parent.data &&
          node.parent.parent.parent.data.name &&
          node.parent.parent.parent.data.name
            .toLowerCase()
            .indexOf(value.toLowerCase()) !== -1 &&
          node.parent.parent.parent.data.id == currentKey;

        let ifFive =
          node.parent &&
          node.parent.parent &&
          node.parent.parent.parent &&
          node.parent.parent.parent.parent &&
          node.parent.parent.parent.parent.data &&
          node.parent.parent.parent.parent.data.name &&
          node.parent.parent.parent.parent.data.name
            .toLowerCase()
            .indexOf(value.toLowerCase()) !== -1 &&
          node.parent.parent.parent.parent.data.id == currentKey;

        let resultOne = false;
        let resultTwo = false;
        let resultThree = false;
        let resultFore = false;
        let resultFive = false;

        if (node.level === 1) {
          resultOne = ifOne;
        } else if (node.level === 2) {
          resultTwo = ifOne || ifTwo;
        } else if (node.level === 3) {
          resultThree = ifOne || ifTwo || ifThree;
        } else if (node.level === 4) {
          resultFore = ifOne || ifTwo || ifThree || ifFour;
        } else if (node.level === 5) {
          resultFore = ifOne || ifTwo || ifThree || ifFour || ifFive;
        }
        return resultOne || resultTwo || resultThree || resultFore || ifFive;
      } else {
        console.log("2");
        let ifOne = data.name.toLowerCase().indexOf(value.toLowerCase()) !== -1;
        let ifTwo =
          node.parent &&
          node.parent.data &&
          node.parent.data.name &&
          node.parent.data.name.toLowerCase().indexOf(value.toLowerCase()) !==
            -1;

        let ifThree =
          node.parent &&
          node.parent.parent &&
          node.parent.parent.data &&
          node.parent.parent.data.name &&
          node.parent.parent.data.name
            .toLowerCase()
            .indexOf(value.toLowerCase()) !== -1;

        let ifFour =
          node.parent &&
          node.parent.parent &&
          node.parent.parent.parent &&
          node.parent.parent.parent.data &&
          node.parent.parent.parent.data.name &&
          node.parent.parent.parent.data.name
            .toLowerCase()
            .indexOf(value.toLowerCase()) !== -1;

        let ifFive =
          node.parent &&
          node.parent.parent &&
          node.parent.parent.parent &&
          node.parent.parent.parent.parent &&
          node.parent.parent.parent.parent.data &&
          node.parent.parent.parent.parent.data.name &&
          node.parent.parent.parent.parent.data.name
            .toLowerCase()
            .indexOf(value.toLowerCase()) !== -1;

        let ifSix =
          node.parent &&
          node.parent.parent &&
          node.parent.parent.parent &&
          node.parent.parent.parent.parent &&
          node.parent.parent.parent.parent.parent &&
          node.parent.parent.parent.parent.parent.data &&
          node.parent.parent.parent.parent.parent.data.name &&
          node.parent.parent.parent.parent.parent.data.name
            .toLowerCase()
            .indexOf(value.toLowerCase()) !== -1;
        //  &&(node.parent.parent.parent.parent.parent.data.id== currentKey)

        let resultOne = false;
        let resultTwo = false;
        let resultThree = false;
        let resultFore = false;
        let resultFive = false;

        if (node.level === 1) {
          resultOne = ifOne;
        } else if (node.level === 2) {
          resultTwo = ifOne || ifTwo;
        } else if (node.level === 3) {
          resultThree = ifOne || ifTwo || ifThree;
        } else if (node.level === 4) {
          resultFore = ifOne || ifTwo || ifThree || ifFour;
        } else if (node.level === 5) {
          resultFore = ifOne || ifTwo || ifThree || ifFour || ifFive;
        }

        return resultOne || resultTwo || resultThree || resultFore || ifFive;
      }
    },
    handleNodeClick(row) {
    },
    handleBtn(id, type) {
      this.filterText = "";
      this.$refs.tree.setCurrentKey(id);
      let node = this.$refs.tree.getCurrentNode();
      this.filterText = node.name;
      this.$refs.tree.filter(this.filterText);
      this.currentNum = id;
    },
  },
};
</script>
<style>
/* lang='scss' */
a:focus {
  outline-style: none;
  -moz-outline-style: none;
}
.custom-tree-node {
  font-size: 12px;
}
.el-tree-node__content {
  word-wrap: break-word;
  word-break: normal;
  cursor: auto;
}

.el-tree > .el-tree-node {
  min-width: 100%;
  display: inline-block;
}
[v-cloak] {
  display: none;
}
.showBox {
  width: 120px;
  height: 30px;
  color: white;
}

.title {
  width: 147px;
  height: 150px;
  /* background: #488FF4; */
  color: #313030;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  font-size: 15px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.circle {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #488ff4;
  margin-right: 10px;
  margin-top: 10px;
}
.commonBtn {
  cursor: pointer;
  border-radius: 5px;
  height: 32px;
}
.commonBtn:hover {
  color: #0080ff !important ;
}
.active:hover {
  color: #0080ff !important ;
}
/* 中间的标题 */
.common {
  cursor: pointer;
}
.common:hover {
  color: #488ff4 !important;
}

.activeColor {
  color: #0080ff !important;
}

.activeCenter {
  color: #0080ff !important;
}
.bigTitle {
  font-size: 14px;
  font-weight: bold;
  color: white;
}
.middleTitle {
  font-size: 12px;
  font-weight: bolder;
}
.smallTitle {
  font-size: 10px;
  font-weight: bolder;
}

.leftChildCommon > div {
  width: 119px;
  line-height: 33px;
  height: 33px;
}
.leftCommon > div {
  width: 98px;
}

.rightChildCommon > div {
  width: 125px;
  margin-bottom: 14px;
  text-align: left;
}

/* 顶部 */
.topCommon {
  position: absolute;
  top: 62px;
  left: 250px;
  display: flex;
}
.topCommon > div {
  height: 30px;
  width: 95px;
  line-height: 30px;
}
.topChildCommon {
  line-height: 30px;
  display: flex;
}
.topChildCommon > div {
  height: 30px;
  width: 77px;
}
/* 底部 */
.bottomCommon {
  position: absolute;
  bottom: 74px;
  left: 252px;
  display: flex;
}
.bottomCommon > div {
  width: 97px;
  border-radius: 5px;
  height: 36px;
}
.bottomChildCommon {
  line-height: 30px;
  display: flex;
}
.bottomChildCommon > div {
  border-radius: 5px;
  height: 30px;
}
</style>